import React from 'react';
import { Section } from './ui/Section';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
const expertise = ['Program & Portfolio Management (PMP)', 'Strategic Planning & Execution', 'Organizational Change Management (PROSCI)', 'Budget & Financial Management', 'Agile & Waterfall Delivery (CSM)', 'PMO Governance & Controls', 'Supply Chain & Logistics Transformation', 'Stakeholder & Executive Engagement', 'Risk Management & Compliance (ISO 9001)', 'Government & Federal Programs (VA)'];
export function Expertise() {
  return <Section id="expertise" background="gray" data-id="element-112">
      <FadeIn className="text-center mb-12" data-id="element-113">
        <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-114">
          Core Expertise
        </h2>
        <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-115">
          Comprehensive leadership capabilities spanning strategy, operations,
          and technical execution.
        </p>
      </FadeIn>

      <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-116">
        {expertise.map((item, index) => <StaggerItem key={index} className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 flex items-start hover:shadow-md transition-shadow duration-200" data-id="element-117">
            <CheckCircle2 className="w-6 h-6 text-[#1e3a8a] mr-4 flex-shrink-0 mt-0.5" data-id="element-118" />
            <span className="text-gray-800 font-medium" data-id="element-119">{item}</span>
          </StaggerItem>)}
      </StaggerContainer>
    </Section>;
}